module.exports = __webpack_public_path__ + "static/img/traject-ubudu.826bfa4.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/traject-ubudu.png
// module id = 956
// module chunks = 2 8